import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import NumberFormat, { FORMAT_PERCENT, FORMAT_CURRENCY } from 'cityads-v3/components/Format/NumberFormat';
import NumberRangeFormat from 'cityads-v3/components/Format/NumberRangeFormat';
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

export function getTargetValue(target) {
  const { webmaster_commission, per_sales_show, per_sales_show_max, webmaster_currency_amount, currency_id, webmaster_currency_id } = target;

  const isPercent = target.per_sales_show ? target.show_percent : Boolean(target.epa_percent);
  const originalMin = per_sales_show ? per_sales_show : webmaster_commission;
  const originalMax = per_sales_show ? (per_sales_show_max ? per_sales_show_max : per_sales_show) : webmaster_commission;
  const hasOriginal = webmaster_currency_id && webmaster_currency_amount && originalMin !== webmaster_currency_amount.min && originalMax !== webmaster_currency_amount.max;

  return {
    format: isPercent ? FORMAT_PERCENT : FORMAT_CURRENCY,
    currency: isPercent ? null : (hasOriginal ? webmaster_currency_id : currency_id),
    min: hasOriginal ? webmaster_currency_amount.min : originalMin,
    max: hasOriginal ? webmaster_currency_amount.max : originalMax,
    originalMin: (!isPercent && hasOriginal) ? originalMin : null,
    originalMax: (!isPercent && hasOriginal) ? originalMax : null,
    originalCurrency: isPercent ? null : currency_id,
  };
}

export default function TargetValueFormat({ format, currency, min, max, originalCurrency, originalMin, originalMax, precision }) {
  const { t } = useTranslation(['Offers']);

  const valueCurrency = Number(currency) || currency;

  const content = (min === max) ?
    (
      <NumberFormat number={min} format={format} currency={valueCurrency} precision={precision} />
    )
    :
    (
      <NumberRangeFormat min={min} max={max} format={format} currency={valueCurrency} precision={precision} />
    );

  const originalContent = (valueCurrency !== originalCurrency && (originalMin || originalMax)) ?
    (
      <TargetValueFormat min={originalMin} max={originalMax} format={format} currency={originalCurrency} precision={precision} />
    )
    :
    null

  if (!originalContent) {
    return content;
  }

  return (
    <Tooltip
      isLight
      title = {<>{t('conversionNotice')} {originalContent}</>}
    >
      <span>{content} *</span>
    </Tooltip>
  )
}

TargetValueFormat.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  originalMin: PropTypes.number,
  originalMax: PropTypes.number,
  format: PropTypes.oneOf([FORMAT_PERCENT, FORMAT_CURRENCY]),
  currency: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  originalCurrency: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  precision: PropTypes.number,
};
